import React from 'react';
import RealFacebookProvider from 'react-facebook';
import fbCredentials from './fbCredentials';

export default class extends React.PureComponent {
  render() {
    return (
      <RealFacebookProvider appId={fbCredentials.appId}>
        {this.props.children}
      </RealFacebookProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/facebook/FacebookProvider.js